var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex my-4"},[_c('h1',{staticClass:"page-title mb-0"},[_vm._v("Settings")])])])}]

export { render, staticRenderFns }